import React from "react";

import { boxForwardRef } from "../../../helpers/common/Box/Box";
import { TextCore } from "../../../helpers/common/TextCore/TextCore";
import { Tooltip } from "../Tooltip";
import { createDisplayNameForTooltipElement } from "../utils/getDisplayName";

import type { BoxComponentWithDefault } from "../../../helpers/common/Box/Box";
import type { OmitOfUnion } from "../../../types/react";
import type { TextProps } from "../../Text";

import classes from "./TooltipText.styl";

const TOOLTIP_TEXT_TEST_ID = "tooltip-text-test-id";

type TooltipTextProps = OmitOfUnion<
    TextProps,
    "textCase" | "underline" | "strikethrough" | "lineHeight" | "italic"
>;

export const TooltipText = boxForwardRef<
    BoxComponentWithDefault<"span", TooltipTextProps, "className">
>(({ typographyStyle, "data-tsid": tsid, children, ...props }, ref) => {
    return (
        <TextCore
            {...props}
            typographyStyle={typographyStyle || "caption-m"}
            textContainerClassName={classes["custom-vars-styles"]}
            data-tsid={tsid || TOOLTIP_TEXT_TEST_ID}
            ref={ref}
        >
            {children}
        </TextCore>
    );
});

Tooltip.displayName = createDisplayNameForTooltipElement("Text");

export default TooltipText;
